import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

export default function SmoothScroll() {
  const location = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.2, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)) });
    window.__lenis = lenis; // exposed so navigation/scroll-reset can command the shared instance
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);

  // Scroll restoration: every navigation (menu taps, links, browser Back/Forward)
  // starts the new page at the top. Both native scroll AND the shared Lenis instance
  // must be reset — resetting only one lets Lenis's stale internal target drag the
  // page back down (the "frozen / lands halfway down" mobile bug). Keyed on
  // location.key so POP navigations reset too. Same-page anchors use
  // scrollIntoView + preventDefault (no location change) and are unaffected.
  useEffect(() => {
    const reset = () => {
      window.scrollTo(0, 0);
      if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    };
    reset();
    const raf = requestAnimationFrame(reset); // re-assert once post-nav effects settle
    return () => cancelAnimationFrame(raf);
  }, [location.key]);

  return null;
}
